module.exports = __webpack_public_path__ + "static/media/phone-icon.0d91fb67.svg";